// Import shared
require('./shared')

// Import widgets
require('../../widgets/quick-search/main')

require('../../../js/core/widget/widget-api')
